module.exports = __webpack_public_path__ + "media/images/icons/chevron-right-19e599143e193520acba4fff3934c10e.svg";